import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { GeneralResult } from '@domain/entities/general';
import { InventoryModel } from '@domain/entities/inventory';
import { InventoryServerModel } from '@domain/entities/inventory';
import { InventoryGateway } from '@domain/gateway/inventory-gateway';

@Injectable({
    providedIn: 'root',
})
export class InventoryService extends InventoryGateway {
    private readonly productEntity = 'v1/products';
    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Get products
     * @param params (Optional)
     * @returns Observable of products entity
     */
    read(params?: HttpParams): Observable<GeneralResult<InventoryServerModel>> {
        return this._http.get<GeneralResult<InventoryServerModel>>(
            `${environment.host}${this.productEntity}`,
            {
                params,
            }
        );
    }

    /**
     * @description Create product
     * @returns Observable of product entity
     */
    create(form: InventoryModel): Observable<InventoryServerModel> {
        return this._http.post<InventoryServerModel>(
            `${environment.host}${this.productEntity}`,
            form
        );
    }

    /**
     * @description Read a product
     * @returns Observable of Product entity description
     */
    readById(id: number): Observable<InventoryServerModel> {
        return this._http.get<InventoryServerModel>(
            `${environment.host}${this.productEntity}/${id}`
        );
    }

    /**
     * @description Update Product
     * @returns Observable of Product entity
     */
    update(id: number, form: InventoryModel): Observable<InventoryServerModel> {
        return this._http.put<InventoryServerModel>(
            `${environment.host}${this.productEntity}/${id}`,
            form
        );
    }

    /**
     * @description Delete Product
     * @returns Observable of Product entity
     */
    delete(id: number): Observable<InventoryServerModel> {
        return this._http.delete<InventoryServerModel>(
            `${environment.host}${this.productEntity}/${id}`
        );
    }

    /**
     * @description Delete Product
     * @returns Observable of Product entity
     */
    upload(file: FormData): Observable<{ src: string }> {
        return this._http.post<{ src: string }>(
            `${environment.host}wp-json/wp/v2/media`,
            file
        );
    }
}
